import { subjectIdFromName } from '@utils/helpers/subjectIdFromName';
import React, { Suspense, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const GenieclassStream = React.lazy(
  () => import('genieclass/GenieclassStream'),
);

const GenieclassStreamPage = () => {
  const { subjectName, onlineClassId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!subjectName || !onlineClassId) {
      navigate('/mathematics/classes');
    }
  }, [navigate, subjectName, onlineClassId]);

  const subjectId: number = subjectIdFromName(subjectName!);
  return (
    <Suspense>
      <GenieclassStream
        online_class_id={parseInt(onlineClassId!)}
        subject_id={subjectId}
      />
    </Suspense>
  );
};

export default GenieclassStreamPage;
